import { useStore } from 'effector-react'
import { UseFormReturn } from 'react-hook-form'
import { uploadPhoto } from '~/features/Registration/helpers'
import { FixButtonWrapper, FormWrapper } from '~/features/Registration/styled'
import {
  countriesOptions,
  DADATA_FMS_UNIT_URL,
} from '~/shared/config/constants'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { Button } from '~/shared/ui/Buttons'
import {
  FormProvider,
  DatePicker,
  TextInput,
  Select,
  PickPhotos,
  DaDataInput,
} from '~/shared/ui/form'
import { FormValues } from './model'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
}

export function Form({ onSuccess, form }: FormProps) {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const { taxiparkIdQuery } = useTaxiparkQueryParams()

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <FormWrapper>
        <Select
          disabled={false}
          options={countriesOptions}
          name='citizenship'
          label='Гражданство'
          modalTitle='Гражданство'
          canSearch
        />
        <TextInput name='passportNumber' label='Серия и номер паспорта' />
        <DatePicker name='birthDate' label='Дата рождения' />
        <DatePicker name='passportIssueDate' label='Дата выдачи паспорта' />

        {featureFlags.address_suggestions_dadata ? (
          <DaDataInput name='registrationAddress' label='Адрес регистрации' />
        ) : (
          <TextInput name='registrationAddress' label='Адрес регистрации' />
        )}

        {featureFlags.address_suggestions_dadata ? (
          <>
            <DaDataInput<{ code: string }>
              name='divisionCode'
              label='Код подразделения'
              url={DADATA_FMS_UNIT_URL}
              renderOption={(suggestion) => {
                return `${suggestion?.data?.code} - ${suggestion?.unrestricted_value}`
              }}
              onMappedSelectedValue={(suggestion) => suggestion?.data?.code}
              onSelected={(suggestion) => {
                form.setValue('passportIssued', suggestion?.value || '')
              }}
            />
            <DaDataInput<{ code: string }>
              name='passportIssued'
              label='Кем выдан паспорт'
              url={DADATA_FMS_UNIT_URL}
              renderOption={(suggestion) => {
                return `${suggestion?.data?.code} - ${suggestion?.unrestricted_value}`
              }}
            />
          </>
        ) : (
          <>
            <TextInput name='divisionCode' label='Код подразделения' />
            <TextInput name='passportIssued' label='Кем выдан паспорт' />
          </>
        )}

        <PickPhotos
          descriptions='Добавьте две фотографии: первого разворота паспорта и прописки'
          name='passportPhotos'
          fnUpload={(file: Blob) => uploadPhoto(file, taxiparkIdQuery)}
          multiple
          maxPhotos={2}
        />

        <FixButtonWrapper>
          <Button variant='limeFlooded' size='large' type='submit' fullWidth>
            Продолжить
          </Button>
        </FixButtonWrapper>
      </FormWrapper>
    </FormProvider>
  )
}
